import React, { FC } from 'react';
import { IStoreySum, IEnrichedStorey } from '@shared/helpers/storeys.helpers';
import { Paper, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { EXPRESSION_VARIABLES_CONSTANTS_ABBREVIATION } from '@shared/constants/calculations.constants';
import { getVariableWithNoConstantObjectBefore } from './calculations.helpers';
import { uniqueId } from 'lodash';
import { getDisplayValueData } from '@shared/helpers/display/get-display-value-data.helper';

interface CalculationValueOverlayProps {
  storeySumExpressionVariables: {
    storeys: IEnrichedStorey[];
    sum: IStoreySum;
  };
  activeVariable: string;
  variableSumValue: string;
}

const CalculationValueOverlay: FC<CalculationValueOverlayProps> = ({
  storeySumExpressionVariables,
  activeVariable,
  variableSumValue,
}) => {
  const { classes, cx } = useStyles();

  return (
    <Paper className={classes.valueOverlay}>
      <Typography
        variant="h6"
        className={cx(
          activeVariable.startsWith(
            EXPRESSION_VARIABLES_CONSTANTS_ABBREVIATION,
          ) && classes.variableConstant,
        )}
      >
        {getVariableWithNoConstantObjectBefore(activeVariable)}
      </Typography>
      <ul className={classes.valueList}>
        <li className={classes.valueListItem}>
          <span style={{ marginRight: 8, fontWeight: 700 }}>
            {activeVariable.startsWith(
              EXPRESSION_VARIABLES_CONSTANTS_ABBREVIATION,
            )
              ? 'Constant'
              : 'Sum'}
            :
          </span>
          <span>{variableSumValue}</span>
        </li>
        {!activeVariable.startsWith(
          EXPRESSION_VARIABLES_CONSTANTS_ABBREVIATION,
        ) &&
          storeySumExpressionVariables.storeys.map((storey, index) => (
            <li key={uniqueId()}>
              <span style={{ marginRight: 8, fontWeight: 700 }}>
                Storey {index}:
              </span>
              {
                getDisplayValueData({
                  value: storey[activeVariable as keyof IEnrichedStorey],
                }).value
              }
            </li>
          ))}
      </ul>
    </Paper>
  );
};

const useStyles = makeStyles()(() => ({
  variableConstant: {
    color: '#999',
  },
  valueOverlay: {
    position: 'fixed',
    bottom: 20,
    left: 20,
    width: 'fit-content',
    minWidth: '21vw',
    padding: 16,
  },
  valueList: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  valueListItem: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
}));

export default CalculationValueOverlay;
